/** Étapes d'onboarding professionnel — parcours A (docs/00-PRODUCT-SPEC.md § 5). */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface OnboardingStep {
  id: string;
  label: string;
  completed: boolean;
}

interface OnboardingState {
  steps: OnboardingStep[];
  activeStepIndex: number;
}

const DEFAULT_STEPS: OnboardingStep[] = [
  { id: 'account', label: 'Création du compte', completed: true },
  { id: 'verify', label: 'Validation e-mail / téléphone', completed: false },
  { id: 'space', label: 'Espace professionnel', completed: false },
  { id: 'trade', label: 'Métier principal', completed: false },
  { id: 'skills', label: 'Compétences secondaires', completed: false },
  { id: 'zone', label: "Zone d'intervention", completed: false },
  { id: 'hours', label: 'Horaires', completed: false },
  { id: 'services', label: 'Services & tarifs', completed: false },
  { id: 'portfolio', label: 'Réalisations', completed: false },
  { id: 'verification', label: 'Éléments de vérification', completed: false },
  { id: 'agent', label: "Configuration de l'agent vocal", completed: false },
  { id: 'publish', label: 'Publication du profil', completed: false },
];

const initialState: OnboardingState = {
  steps: DEFAULT_STEPS.map((s) => ({ ...s })),
  activeStepIndex: 0,
};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setStepCompleted(state, action: PayloadAction<{ stepId: string; completed: boolean }>) {
      const step = state.steps.find((s) => s.id === action.payload.stepId);
      if (step) step.completed = action.payload.completed;
    },
    setActiveStepIndex(state, action: PayloadAction<number>) {
      state.activeStepIndex = Math.max(0, Math.min(action.payload, state.steps.length - 1));
    },
    resetOnboarding() {
      return { steps: DEFAULT_STEPS.map((s) => ({ ...s })), activeStepIndex: 0 };
    },
  },
});

export const { setStepCompleted, setActiveStepIndex, resetOnboarding } = onboardingSlice.actions;

export const selectOnboardingProgress = (state: { onboarding: OnboardingState }) => {
  const done = state.onboarding.steps.filter((s) => s.completed).length;
  return Math.round((done / state.onboarding.steps.length) * 100);
};
